var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartitup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 956.8 418.9",
    style: {
      enableBackground: "new 0 0 956.8 418.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF433C;}\n\t.st1{fill:#fff;}\n\t.textFill{fill:#fff}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.8,43.3c-72.3,0-134.4,44.3-160.7,107.2h18.6c25.1-53.3,79.4-90.2,142.1-90.2c86.6,0,157,70.4,157,157 s-70.4,157-157,157c-62.3,0-116.3-36.5-141.6-89.2h-18.7c26.5,62.4,88.3,106.2,160.3,106.2c95.9,0,174-78.1,174-174 C904.8,121.4,826.7,43.3,730.8,43.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 270.3,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1153.7839 555.3677)",
    className: "st1",
    width: 1.8,
    height: 14.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.7,260.1c-1.5-1.2-2.1-2.1-0.8-4.5l5.4-9.3c1.2-2.1,3.8-2.1,5.1-1c6.2,4.7,12.9,9.3,22.7,9.3c7.8,0,13.7-5.1,13.7-11.6 c0-7.7-6.5-12.9-19.1-18c-14.1-5.7-28.2-14.7-28.2-32.4c0-13.4,9.9-28.8,33.8-28.8c15.3,0,27,7.8,30,10.1c1.5,0.9,2,3.5,0.9,5 l-5.7,8.6c-1.2,1.8-3.5,3-5.3,1.8c-6.5-4.1-12.6-8.3-20.9-8.3c-8.6,0-13.2,4.8-13.2,10.5c0,7.1,5.6,11.9,17.7,16.8 c14.6,5.9,31.4,14.6,31.4,33.9c0,15.5-13.4,29.7-34.5,29.7C81.8,271.8,72.1,263.9,67.7,260.1z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,183.3h-23c-1.7,0-2.9-1.4-2.9-2.9v-12.3c0-1.5,1.2-2.9,2.9-2.9h65.6c1.7,0,2.9,1.4,2.9,2.9v12.3 c0,1.5-1.2,2.9-2.9,2.9h-23v84.2c0,1.5-1.4,2.9-2.9,2.9h-14c-1.5,0-2.9-1.3-2.9-2.9V183.3z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8,266.4l46.7-101c0.5-0.9,1.2-1.6,2.6-1.6h1.5c1.5,0,2.1,0.8,2.6,1.6l46.2,101c0.9,2-0.3,3.9-2.5,3.9h-13.1 c-2.3,0-3.3-0.9-4.4-3l-7.4-16.2h-44.9l-7.4,16.2c-0.6,1.5-2,3-4.4,3h-13.1C214.1,270.3,212.9,268.4,213.8,266.4z M278.6,234.5 l-15-33h-0.5l-14.7,33H278.6z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.5,168.2c0-1.5,1.2-2.9,2.9-2.9h42.9c18,0,32.7,14.4,32.7,32.3c0,13.8-9.2,25.1-22.2,30.3l20.6,38.1 c1,2,0,4.4-2.6,4.4H385c-1.4,0-2.1-0.8-2.4-1.3l-20-39.8H346v38.3c0,1.5-1.4,2.9-2.9,2.9h-13.8c-1.7,0-2.9-1.3-2.9-2.9V168.2z  M370.6,213.2c8,0,14.9-6.9,14.9-15.3c0-8-6.9-14.6-14.9-14.6h-24.5v29.9H370.6z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.4,183.3h-23c-1.7,0-2.9-1.4-2.9-2.9v-12.3c0-1.5,1.2-2.9,2.9-2.9H485c1.6,0,2.8,1.4,2.8,2.9v12.3 c0,1.5-1.2,2.9-2.8,2.9h-23v84.2c0,1.5-1.4,2.9-2.9,2.9h-14c-1.5,0-2.9-1.3-2.9-2.9V183.3z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.5,168.2c0-1.5,1.3-2.9,2.8-2.9h14c1.5,0,2.9,1.4,2.9,2.9v99.3c0,1.5-1.4,2.9-2.9,2.9h-14c-1.5,0-2.8-1.3-2.8-2.9 V168.2z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.6,183.3h-23c-1.6,0-2.8-1.4-2.8-2.9v-12.3c0-1.5,1.2-2.9,2.8-2.9h65.6c1.6,0,2.8,1.4,2.8,2.9v12.3 c0,1.5-1.2,2.9-2.8,2.9h-23v84.2c0,1.5-1.3,2.9-2.8,2.9h-14c-1.5,0-2.8-1.3-2.8-2.9V183.3z",
    className: "textFill"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "628.8,187.8 648.4,157 668.3,187.8  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M637.2,199.6c0-1.6,1.5-3.1,3.1-3.1h15.5c1.8,0,3.1,1.5,3.1,3.1v33.7c0,13.9,9.5,23.5,23.7,23.5s23.9-9.6,23.9-23.4v-68.3 c0-1.6,1.3-3.1,3.1-3.1h15.5c1.6,0,3.1,1.5,3.1,3.1v69.3c0,24.9-19.8,43.7-45.6,43.7c-25.7,0-45.5-18.8-45.5-43.7V199.6z",
    className: "textFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.9,165.2c0-1.6,1.3-3.1,3.1-3.1h38.4c20.1,0,36.6,16.4,36.6,36.1c0,20.3-16.5,36.8-36.5,36.8h-20.4l0,40.1 c0,1.6-1.5,3.1-3.1,3.1h-15c-1.8,0-3.1-1.5-3.1-3.1L754.9,165.2z M795.8,215c9.2,0,16.2-7.4,16.2-17c0-9-7-15.9-16.2-15.9h-19.6 V215H795.8z",
    className: "textFill"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartitup);
export default __webpack_public_path__ + "static/media/startitup.ccc178e550c1b09149c6356cb711c482.svg";
export { ForwardRef as ReactComponent };